import {ALookupRowsContainer} from "./lookup.rows.container";
import {PpsItem} from "./pps.item";
import {LinkedReport} from "./linked.report";
import {LinkedPps} from "./linked.pps";
import {Inventory} from "./inventory";
import { Interpretation } from "app.services/clinical/blind.read/models/interpretation";

export class Pps extends ALookupRowsContainer {
	static PpsItem_TYPE;

	ppsKey: number;
	patientPersonKey: number;
	ppsCodeKey: number;
	description: string;
	modalityKey: number;
	ppsItem: PpsItem[];
	technurseNotes: string;
	statusKey: number;
	reportKey: number;
	startDatetime: Date;
	endDatetime: Date;
	protocolKey;
	linkedId: number;
	linkedPps: LinkedPps[];
	linkedReport: LinkedReport[];
	inventoryItems: Inventory[];
	interpretation: Interpretation[]
	lateralityKey: number;

	// public SetData(spsCode: ISPSCode, procedureCode: IProcedureCode){
	// 	this.ppsCodeKey = spsCode.SPSCodeKey;
	// 	this.description = spsCode.description;
	// 	this.FKLookupRows = {ppsCodeKey: spsCode};
	//
	// 	let ppsItem = new PpsItem();
	// 	let sequenceId = this.getNextSequenceId();
	// 	ppsItem.SetData(procedureCode, sequenceId);
	// 	this.ppsItem = [ppsItem];
	// }

	// public addPpsItem(procedureCode: IProcedureCode){
	// 	let currPpsItem: PpsItem;
	// 	if (this.ppsItem) {
	// 		//Check if pps item array contain the procedureCode.
	// 		currPpsItem = this.ppsItem.find((ppsItem) => {
	// 			return procedureCode.procedureCodeKey === ppsItem.procedureCodeKey;
	// 		});
	// 	} else {
	// 		this.ppsItem = [];
	// 	}
	//
	// 	if (!currPpsItem) {
	// 		//Add a new pps item.
	// 		let createPpsItem = new PpsItem();
	// 		createPpsItem.SetData(procedureCode, this.getNextSequenceId());
	// 		this.ppsItem.push(createPpsItem);
	// 	}
	// }
	//
	// public getNextSequenceId(){
	// 	return (this.ppsItem && this.ppsItem.length) ? this.ppsItem[this.ppsItem.length - 1].sequenceId + 1 : 1;
	// }
}
Pps.PpsItem_TYPE = PpsItem;
